// 그림(JPEG) 한 장을 A4 한 쪽짜리 PDF 로 감싼다 — 라이브러리 없이 바이트를 직접 조립한다.
// 글자가 아니라 그림이라 한글이 깨지지 않는다. (카톡 견적서 PDF 첨부용, 판 #619)
const A4_W = 595;
const A4_H = 842;
const MARGIN = 28;

function ascii(s) {
  const out = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i) & 0xff;
  return out;
}

function concat(chunks) {
  let n = 0;
  for (const c of chunks) n += c.length;
  const out = new Uint8Array(n);
  let o = 0;
  for (const c of chunks) { out.set(c, o); o += c.length; }
  return out;
}

const num = (v) => String(Math.round(v * 100) / 100);

/**
 * @param {Uint8Array} jpeg  JPEG 바이트
 * @param {number} imgW 그림 가로(px)  @param {number} imgH 그림 세로(px)
 * @returns {Uint8Array} PDF 바이트 (1쪽)
 */
export function buildImagePdf(jpeg, imgW, imgH) {
  if (!(jpeg instanceof Uint8Array) || jpeg.length < 4 || jpeg[0] !== 0xff || jpeg[1] !== 0xd8) throw new Error('JPEG 그림이 아닙니다');
  if (!(imgW > 0) || !(imgH > 0)) throw new Error('그림 크기가 올바르지 않습니다');
  // 쪽 안쪽(여백 뺀 곳)에 비율 그대로 맞춘다. 위쪽 정렬.
  const boxW = A4_W - MARGIN * 2;
  const boxH = A4_H - MARGIN * 2;
  const scale = Math.min(boxW / imgW, boxH / imgH);
  const w = imgW * scale;
  const h = imgH * scale;
  const x = (A4_W - w) / 2;
  const y = A4_H - MARGIN - h;
  const content = `q ${num(w)} 0 0 ${num(h)} ${num(x)} ${num(y)} cm /Im0 Do Q`;

  const objs = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
    `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${A4_W} ${A4_H}] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>`,
    `<< /Length ${content.length} >>\nstream\n${content}\nendstream`
  ].map(ascii);
  const imgHead = ascii(`<< /Type /XObject /Subtype /Image /Width ${Math.round(imgW)} /Height ${Math.round(imgH)} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpeg.length} >>\nstream\n`);
  const imgTail = ascii('\nendstream');

  const chunks = [ascii('%PDF-1.4\n%\xe2\xe3\xcf\xd3\n')];
  const offsets = [];
  let pos = chunks[0].length;
  const push = (...parts) => { for (const p of parts) { chunks.push(p); pos += p.length; } };
  for (let i = 0; i < 4; i++) {
    offsets.push(pos);
    push(ascii(`${i + 1} 0 obj\n`), objs[i], ascii('\nendobj\n'));
  }
  offsets.push(pos);
  push(ascii('5 0 obj\n'), imgHead, jpeg, imgTail, ascii('\nendobj\n'));
  const xrefAt = pos;
  let xref = 'xref\n0 6\n0000000000 65535 f \n';
  for (const o of offsets) xref += String(o).padStart(10, '0') + ' 00000 n \n';
  push(ascii(xref + `trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xrefAt}\n%%EOF\n`));
  return concat(chunks);
}

/** canvas → PDF Blob (브라우저 전용). JPEG 로 굳혀서 감싼다(투명 부분은 호출 쪽에서 흰 바탕으로 그려 둔다). */
export function canvasToPdfBlob(canvas) {
  const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
  const bin = atob(dataUrl.split(',')[1] || '');
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([buildImagePdf(bytes, canvas.width, canvas.height)], { type: 'application/pdf' });
}
